export type FrisbiiErrorCode = 'account_exists' | 'already_subscribed' | 'payment_failed' | 'session_expired' | 'unknown';

export class FrisbiiError extends Error {
  code: FrisbiiErrorCode;

  constructor(code: FrisbiiErrorCode, originalError?: Error) {
    super(originalError?.message, originalError ? { cause: originalError } : undefined);
    this.code = code;
  }
}
